import router from "@/router/index";
import { Options, Vue } from "vue-class-component";

@Options({
  name: "menu-header",
})
export default class Menu extends Vue {
  public openCredentials() {
    router.replace("/credentials");
  }

  public openReclassify() {
    router.replace("/reclassify");
  }
}
